import TwoLineCardsComponet from './TwoLineCards';

const TwoLineCards = {
  getSettings: componentSettings => ({
    ...componentSettings,
    VariantComponent: TwoLineCardsComponet,
    modifier: 'two-line-cards'
  })
};

export default TwoLineCards;
